"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentConsentClient = void 0;
class DocumentConsentClient {
    constructor(authServiceWeConnect, localeService, stage) {
        this.authServiceWeConnect = authServiceWeConnect;
        this.localeService = localeService;
        this.stage = stage;
        this.getGdcType = (isWcar) => (isWcar ? `myvw-wcar-${this.stage}` : `myvw-mbb-${this.stage}`);
        this.locale = `${this.localeService.language}-${this.localeService.countryCode}`;
        /**
         * The condition below is a special handling of Norwegian
         * market. The language-country code of this market
         * is 'no-NO', but this particular API would return
         * 'No concents for this language'. Therefore, we ask for
         * 'nb-NO' language-country code for this case.
         */
        if (this.localeService.language === 'no' && this.localeService.countryCode === 'NO') {
            this.locale = 'nb-NO';
        }
        this.resourceHostId = `myvw-document-consent-${stage}`;
    }
    async getDocumentConsentRequired(isWcar, documentId, userId) {
        const documentConsentUrl = 'api/v2/consents/required';
        let response = await this.authServiceWeConnect.get(this.resourceHostId, `${documentConsentUrl}?gdc=${this.getGdcType(isWcar)}&document-id=${documentId}&user-id=${userId}&locale=${this.locale}`);
        if (!response.ok) {
            throw new Error();
        }
        return (await response.json());
    }
    async postDocumentConsent(isWcar, userId, versionDetailsId, decision) {
        const endpoint = `api/v2/consents`;
        const response = await this.authServiceWeConnect.post(this.resourceHostId, `${endpoint}?gdc=${this.getGdcType(isWcar)}&user-id=${userId}&locale=${this.locale}`, JSON.stringify({ userId, versionDetailsId, decision }), { 'Content-Type': 'application/json' });
        if (!response.ok) {
            throw new Error();
        }
        return (await response.json());
    }
    async putDocumentConsent(isWcar, userId, consentId, decision) {
        const endpoint = `api/v2/consents/${consentId}`;
        const response = await this.authServiceWeConnect.put(this.resourceHostId, `${endpoint}?gdc=${this.getGdcType(isWcar)}&user-id=${userId}&locale=${this.locale}`, JSON.stringify({ decision }), { 'Content-Type': 'application/json' });
        if (!response.ok) {
            throw new Error();
        }
        return (await response.json());
    }
}
exports.DocumentConsentClient = DocumentConsentClient;
//# sourceMappingURL=DocumentConsentClient.js.map